import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { StepButtons, StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import { ProgramEnum, ProgramWeekEnum } from 'src/modules/programs/models/programs';
import { getProgramWeeksDataByProgramId } from 'src/modules/programs/selectors/programsSelectors';
import * as S from 'src/modules/programs/stepComponents/styles';

import { CorePillarRateSlider } from '../../components/CorePillarRateSlider';
import { CPProgramWeek } from '../../models/cpProgram';
import { changeCorePillarRating, submitCorePillarsRatingForm } from '../actions/weekSharedActions';
import { CorePillarsRating } from '../models/weekShared';
import { getCorePillarsRating } from '../selectors/weekSharedSelectors';

interface StateProps {
    weeks: CPProgramWeek[];
    rating: CorePillarsRating;
}

interface ActionsProps {
    changeCorePillarRating: typeof changeCorePillarRating;
    submitCorePillarsRatingForm: typeof submitCorePillarsRatingForm;
}

interface Props extends StepButtonsProps, StateProps, ActionsProps, WithTranslation {
    week: CPProgramWeek;
}

class CorePillarsCheckInStepContainer extends React.Component<Props> {
    public changeValue = (weekId: ProgramWeekEnum, value: number) =>
        this.props.changeCorePillarRating({ weekId, value });

    private handleFormSubmit = () => {
        this.props.submitCorePillarsRatingForm();
        this.props.goToNextStep();
    };

    public render(): JSX.Element {
        const { t } = this.props;

        return (
            <>
                <S.ContentRow>
                    <S.ContentColumn textalign="center">
                        <S.StepHeading small>
                            {t('shared.core-pillars-check-in.heading')}
                        </S.StepHeading>
                        <S.StepHeading> {t('shared.core-pillars-check-in.title')}</S.StepHeading>
                        <S.StepDescription small>
                            {t('shared.core-pillars-check-in.description')}
                        </S.StepDescription>
                    </S.ContentColumn>
                </S.ContentRow>
                <S.ContentRow>
                    <S.ContentColumn>
                        {this.props.weeks.map(week => (
                            <CorePillarRateSlider
                                key={week.id}
                                pillarId={week.id}
                                title={week.title}
                                definition={week.definition}
                                value={this.props.rating[week.id]}
                                minValue={1}
                                maxValue={5}
                                minLabelText={t('shared.core-pillars-check-in.poorSliderLabel')}
                                maxLabelText={t('shared.core-pillars-check-in.greatSliderLabel')}
                                onChangeValue={this.changeValue}
                            />
                        ))}
                    </S.ContentColumn>
                </S.ContentRow>
                <StepButtons
                    onPreviousClick={this.props.goToPreviousStep}
                    onNextClick={this.handleFormSubmit}
                    hasNextStep
                    inStep
                />
            </>
        );
    }
}

const mapStateToProps = (state: AppState): StateProps => ({
    weeks: getProgramWeeksDataByProgramId(state, ProgramEnum.CP) as CPProgramWeek[],
    rating: getCorePillarsRating(state),
});

export const CorePillarsCheckInStep = withTranslation('cp')(
    connect(mapStateToProps, {
        changeCorePillarRating,
        submitCorePillarsRatingForm,
    })(CorePillarsCheckInStepContainer),
);
